import React, { useState } from 'react';
import Privacy from '../../pages/Privacy';
import LanguageToggle from './LanguageToggle';

export default function PrivacyPolicyPage() {
  const [language, setLanguage] = useState('de');

  return (
    <section className="relative mx-auto w-full max-w-5xl px-6 pb-24 pt-28 text-white lg:px-16">
      <div className="pointer-events-none absolute inset-x-0 top-10 -z-10 h-64 rounded-full bg-gradient-to-r from-[#8b5cf6]/25 via-transparent to-[#ec4899]/25 blur-3xl" />
      <header className="mb-10 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-3">
          <p className="text-sm uppercase tracking-[0.35em] text-white/60">Transparency</p>
          <h1 className="text-4xl font-semibold leading-tight md:text-5xl">Privacy Policy</h1>
          <p className="max-w-3xl text-lg text-white/70">
            Learn how NumSolve handles your data.
          </p>
        </div>
        <LanguageToggle value={language} onToggle={() => setLanguage(language === 'de' ? 'en' : 'de')} />
      </header>
      <div className="rounded-3xl border border-white/10 bg-white/90 text-slate-900 shadow-[0_35px_65px_-45px_rgba(76,29,149,0.8)] backdrop-blur">
        <Privacy language={language} />
      </div>
    </section>
  );
}
